import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { locales } from "../../locales";

ChartJS.register(ArcElement, Tooltip, Legend);

const colors = {
  men: "#86CDEB",
  women: "#E88B00",
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 20,
  },
  plugins: {
    legend: {
      labels: {
        boxWidth: 31,
        boxHeight: 23,
        color: "#000",
      },
      display: true,
      position: "bottom",
      align: "start",
    },
    tooltip: {
      enabled: false,
    },
  },
};

const optionsDesktop = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 10,
  },
  tooltips: {
    enabled: false,
  },
  plugins: {
    legend: {
      labels: {
        boxWidth: 16,
        boxHeight: 16,
        color: "#000",
      },
      display: true,
      position: "bottom",
      align: "start",
    },
  },
};

// plugins
// const doughnutLabelsLine = {
//   id: "doughnutLabelsLine",
//   afterDraw: (chart, args, options) => {
//     const {
//       ctx,
//       chartArea: { width, height },
//     } = chart;

//     chart.data.datasets.forEach((dataset, i) => {
//       chart.getDatasetMeta(i).data.forEach((datapoint, j) => {
//         const { x, y } = datapoint.tooltipPosition();

//         // draw line to label text
//         const halfWidth = width / 2;
//         const halfHeight = height / 2;
//         const xLine = x >= halfWidth ? x + 15 : x - 15;
//         const yLine = y >= halfHeight ? y + 20 : y - 20;
//         const extraLine = x >= halfWidth ? 15 : -15;

//         // line from datapoint to label text
//         ctx.beginPath();
//         ctx.moveTo(x, y);
//         ctx.lineTo(xLine, yLine);
//         ctx.lineTo(xLine + extraLine, yLine);
//         ctx.strokeStyle = dataset.backgroundColor[j];
//         ctx.stroke();

//         // control the position of the text
//         const textXPosition = x >= halfWidth ? "left" : "right";
//         const plusFivePx = x >= halfWidth ? 5 : -5;
//         // const numberOfSeats = dataset.data[j];
//         ctx.font = "12px Fira Sans Condensed";
//         ctx.textAlign = textXPosition;
//         ctx.textBaseline = "middle";
//         ctx.fillText(
//           chart.data.labels[j],
//           xLine + extraLine + plusFivePx,
//           yLine
//         );
//       });
//     });
//   },
// };

const GenderRepresentation = ({
  data,
  langId,
  isDesktop,
  coalitionsGender,
}) => {
  const total = data.men + data.women;
  let percentages;

  if (coalitionsGender) {
    percentages = {
      men: coalitionsGender.men,
      women: coalitionsGender.women,
    };
  } else {
    percentages = {
      men: Math.round((data.men / total) * 100),
      women: Math.round((data.women / total) * 100),
    };
  }

  const labels = Object.keys(percentages).filter((label) => label in colors);
  const inputData = labels.map((label) => percentages[label]);
  const backgroundColor = labels.map((label) => colors[label]);
  const localizedLabels = labels.map(
    (label) => locales[langId].gender[label] + " (" + percentages[label] + "%)"
  );

  const chartObject = {
    labels: localizedLabels,
    datasets: [
      {
        label: "",
        data: inputData,
        backgroundColor: backgroundColor,
        borderWidth: 1,
      },
    ],
  };

  return (
    <Doughnut
      data={chartObject}
      options={isDesktop ? optionsDesktop : options}
      // plugins={isDesktop ? [doughnutLabelsLine] : []}
    />
  );
};

export default GenderRepresentation;
